import React, { useState, useEffect } from 'react';
import { INITIAL_ROUTES } from '../data/mockData';
import { getRoutes } from '../api';
import { Check, Search } from 'lucide-react';
import { Input } from './ui/input';

const PricingList = () => {
  const [routes, setRoutes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const loadData = async () => {
        const data = await getRoutes();
        if (data && data.length > 0) {
            setRoutes(data);
        } else {
            setRoutes(INITIAL_ROUTES);
        }
    };
    loadData();
  }, []);

  const filteredRoutes = routes.filter(route => 
    route.to.toLowerCase().includes(searchTerm.toLowerCase()) || 
    route.from.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section id="fiyatlar" className="py-32 bg-[#121212] text-white min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-accordion-down">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Popüler <span className="text-yellow-500">Transfer</span> Fiyatları
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Antalya Havalimanı çıkışlı en çok tercih edilen transfer bölgelerimiz ve güncel fiyat listemiz.
          </p>
          
          {/* Search Bar */}
          <div className="max-w-md mx-auto relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
            <Input 
                placeholder="Bölge ara (Örn: Alanya, Belek)..." 
                className="pl-10 bg-[#1a1a1a] border-white/10 text-white h-12 focus:ring-yellow-500/50"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="space-y-4">
            {filteredRoutes.length > 0 ? (
                filteredRoutes.slice(0, 15).map((route, idx) => (
                    <div key={idx} className="group relative bg-[#1a1a1a] border border-white/5 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between hover:border-yellow-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-900/10">
                        <div className="flex items-center gap-6 w-full sm:w-auto mb-4 sm:mb-0">
                            <div className="h-12 w-12 rounded-full bg-white/5 flex items-center justify-center text-yellow-500 group-hover:bg-yellow-500 group-hover:text-black transition-colors shrink-0">
                                <Check className="h-6 w-6" />
                            </div>
                            <div>
                                <h4 className="font-bold text-xl text-white group-hover:text-yellow-500 transition-colors">{route.to}</h4>
                                <p className="text-sm text-gray-400 flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-white/20"></span>
                                    {route.from} ➔ {route.to}
                                </p>
                            </div>
                        </div>
                        <div className="text-right w-full sm:w-auto border-t sm:border-t-0 border-white/10 pt-4 sm:pt-0 flex sm:block justify-between items-center">
                            <span className="block text-3xl font-black text-white">{route.price} <span className="text-lg font-medium text-yellow-500">TL</span></span>
                            <a href={`https://wa.me/905468953037?text=Merhaba, ${route.from} - ${route.to} transferi için rezervasyon yapmak istiyorum.`} target="_blank" rel="noopener noreferrer" className="inline-block mt-1 text-sm font-bold text-green-500 hover:text-green-400 uppercase tracking-wider">
                                Hemen Kirala →
                            </a>
                        </div>
                    </div>
                ))
            ) : (
                <div className="text-center py-12 text-gray-500">
                    Aradığınız kriterde bir rota bulunamadı. Lütfen bizimle iletişime geçin.
                </div>
            )}
        </div>
        
        <div className="text-center mt-12">
            <p className="text-gray-500 text-sm mb-4">*Fiyatlar araç başı olup, tek yön transfer ücretidir. KDV dahildir.</p>
            <a href="https://wa.me/905468953037" className="inline-flex items-center justify-center px-8 py-3 border border-yellow-500/30 rounded-full text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold transition-all duration-300">
                Özel Rota İçin Fiyat Al
            </a>
        </div>

      </div>
    </section>
  );
};

export default PricingList;
